"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryManageGroup = void 0;
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const edit_1 = require("client/components/icons/edit");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const Delete_1 = require("material-ui-icons/Delete");
const Button_1 = require("material-ui/Button");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const html5sortable_es_js_1 = require("../../../../../../lib/html5sortable.es.js");
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["Empty"] = "Invalid: group name cannot be empty";
    ErrorMessage["Duplicate"] = "Invalid: no duplicates allow";
    ErrorMessage["Invalid"] = "Invalid: character must be [A-Z, 0-9, _, -]";
})(ErrorMessage || (ErrorMessage = {}));
const columns = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "Name",
        id: "name"
    },
    {
        label: "qty2run",
        id: "qty"
    },
    {
        label: "old",
        id: "priority"
    },
    {
        label: "new",
        id: "priority"
    }
];
const columnsUngrouped = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "Name",
        id: "name"
    },
    {
        label: "qty2run",
        id: "qty"
    },
    {
        label: "",
        id: "old"
    },
    {
        label: "",
        id: "new"
    }
];
let InventoryManageGroup = class InventoryManageGroup extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "priority";
        this.newQuantityToRun = {};
        this.showChildren = {};
        this.groupToBeRemoved = null;
        this.showGroupEditModal = false;
        this.groupTextEditing = "";
        this.showGroupRemoveConfirmation = false;
        // @observable
        // public showConfirmationGroupManagementSave: boolean = false;
        this.groupTitleEditMode = false;
        this.invalidGroupText = false;
        this.errorMessage = "";
        /** Delete an inventory group and estrange the inventories it contains */
        this.handleGroupRemove = (row) => (event) => {
            event.stopPropagation();
            this.showGroupRemoveConfirmation = true;
            this.groupToBeRemoved = row.group; // Pass along the group row and use its unique name to query and delete from the db.
        };
        /** Set the row to edit */
        this.handleEditInventoryGroup = (row) => async (event) => {
            event.stopPropagation();
            this.rowToEdit = row;
            this.groupTextEditing = row.group;
            this.showGroupEditModal = true;
        };
        /** Controls the quantity to run edit */
        this.handleQuantityEdit = (child) => (event) => {
            const { value = "" } = event.currentTarget;
            this.newQuantityToRun[child.id] = value;
        };
        this.getGetOrdinal = (n) => {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        };
        /**
         * Make the items in the specified container class name sortable.
         */
        this.makeSortable = (sortableClass, options) => {
            // options = options || {};
            // sortableClass = sortableClass || "sortable";
            // UNGROUPED
            const ungrouped = html5sortable_es_js_1.default(".sortable__group-management--notset", {
                acceptFrom: ".sortable__group-management--notset,.sortable__group-management--group"
            });
            // Update state of inventories priority.
            // Set priority to empty
            if (ungrouped && Array.isArray(ungrouped) && ungrouped.length) {
                ungrouped.forEach(group => {
                    group.addEventListener("sortupdate", (e) => {
                        const originGroup = e.detail.origin.container.dataset.group;
                        const destinationGroup = e.detail.destination.container.dataset.group;
                        [...e.target.children].forEach(inventory => {
                            // Handle displaying "no-rows" child
                            if (inventory.classList.contains("no-rows")) {
                                if (inventory.parentNode.children.length > 1) {
                                    inventory.style.display = "none";
                                }
                                else {
                                    inventory.style.display = "block";
                                }
                            }
                            inventory.lastChild.innerText = "";
                        });
                        if (originGroup !== "") {
                            [...e.detail.origin.container.children].forEach((inventory, index) => {
                                inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                            });
                        }
                    });
                });
            }
            // GROUPED
            const grouped = html5sortable_es_js_1.default(".sortable__group-management--group", {
                acceptFrom: ".sortable__group-management--notset,.sortable__group-management--group",
                containerSerializer: (serializedContainer) => serializedContainer
            });
            // If sorting within the same container.
            if (grouped && Array.isArray(grouped) && grouped.length) {
                grouped.forEach(group => {
                    group.addEventListener("sortupdate", (e) => {
                        const originGroup = e.detail.origin.container.dataset.group;
                        const destinationGroup = e.detail.destination.container.dataset.group;
                        const noRowsItem = e.target.getElementsByClassName("no-rows");
                        [...noRowsItem].forEach(row => {
                            row.parentNode.removeChild(row);
                            this.makeSortable();
                        });
                        [...e.detail.destination.container.children].forEach((inventory, index) => {
                            // If sorting withing same container
                            if (originGroup === destinationGroup) {
                                if (originGroup === "") {
                                    // do nothing
                                }
                                else {
                                    // set priority based on index and update the rest of the group inventory priorities.
                                    inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                                }
                            }
                            // If sorting to another group container
                            if (originGroup !== destinationGroup) {
                                //  If destination container is ungrouped, set priority to empty
                                if (destinationGroup === "") {
                                    inventory.lastChild.innerText = "";
                                }
                                else {
                                    inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                                }
                            }
                        });
                        [...e.detail.origin.container.children].forEach((inventory, index) => {
                            // If sorting withing same container
                            if (originGroup === destinationGroup) {
                                if (originGroup === "") {
                                    // do nothing
                                }
                                else {
                                    // set priority based on index and update the rest of the group inventory priorities.
                                    inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                                }
                            }
                            // If sorting to another group container
                            if (originGroup !== destinationGroup) {
                                //  If destination container is ungrouped, set priority to empty
                                if (destinationGroup === "") {
                                    // inventory.lastChild.innerText = "";
                                    inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                                }
                                else {
                                    if (originGroup !== "") {
                                        inventory.lastChild.innerHTML = `${this.getGetOrdinal(index + 1)}`;
                                    }
                                }
                            }
                        });
                    });
                });
            }
        };
        /** Render the inventory groups on group management mode */
        this.renderGroupedListChildManagementGroup = (child, index) => (React.createElement(list_item_1.MaterialListItem, { onClick: () => this.makeSortable(), key: index, inventoryId: child.id, inventoryPriority: child.priority, quantityToRun: child.claimQuantity },
            React.createElement(list_item_text_1.MaterialListItemText, { primary: child.package }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: child.strengthDescription || child.name || child.generic }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(core_1.TextField, { id: "standard-with-placeholder", label: child.claimQuantity, placeholder: "Enter new qty 2 run", className: "edit-qty-2-run", margin: "normal", onChange: this.handleQuantityEdit(child), value: this.newQuantityToRun[child.id] }) }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "old-priority-accent", primary: child.priority !== 0 && this.getGetOrdinal(child.priority) }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: child.priority !== 0 && this.getGetOrdinal(child.priority) })));
        /** Render the ungrouped inventory list on group management mode */
        this.renderGroupedListChildManagementNotSet = (child, index) => (React.createElement(list_item_1.MaterialListItem, { onClick: () => this.makeSortable(), key: index, inventoryId: child.id, inventoryPriority: child.priority, quantityToRun: child.claimQuantity },
            React.createElement(list_item_text_1.MaterialListItemText, { primary: child.package }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: child.strengthDescription || child.name || child.generic }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(core_1.TextField, { id: "standard-with-placeholder", label: child.claimQuantity, placeholder: "Enter new qty 2 run", className: "edit-qty-2-run", margin: "normal", onChange: this.handleQuantityEdit(child), value: this.newQuantityToRun[child.id] }) }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "old-priority-accent", primary: "" }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: "" })));
        /** Render the ungrouped inventory list to be mapped in group management mode */
        this.renderGroupedListRowManagementNotSet = (row, index) => (React.createElement("div", { key: index },
            React.createElement(list_1.MaterialListSortable, { rows: row.children, renderRow: this.renderGroupedListChildManagementNotSet, makeSortable: this.makeSortable })));
        /** Render the groups list to add to/from in group management mode */
        this.renderGroupedListRowManagementGroup = (row, index) => (React.createElement("div", { key: index },
            React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                    this.handleClickGroup(index);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` }),
                React.createElement("div", { className: "edit-group" }, row.group !== "" && ( // omit group not set
                React.createElement(React.Fragment, null,
                    React.createElement(ReactTooltip, { delayShow: 4000 }),
                    React.createElement(Button_1.default, { "data-tip": "Edit group name", className: "edit-group__remove-button", onClick: this.handleEditInventoryGroup(row), color: "default" },
                        React.createElement(edit_1.EditIcon, null)),
                    React.createElement(Button_1.default, { "data-tip": "Remove group", className: "edit-group__remove-button", 
                        // onClick={this.handleGroupRemove(row)}
                        onClick: this.handleGroupRemove(row), color: "default" },
                        React.createElement(Delete_1.default, null)))))),
            React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                React.createElement(list_1.MaterialListSortable, { rows: row.children, renderRow: this.renderGroupedListChildManagementGroup, makeSortable: this.makeSortable, rowGroup: row.group }))));
        this.renderGroupedListManagement = () => {
            const { inventory: { value = [] } } = store_1.inventoryListStore;
            let groupListFromDB = store_1.inventoryListStore.inventoryGroups.value || [];
            // filter duplicates and prepend grouplist before passing the groups to be rendered.
            groupListFromDB = groupListFromDB.filter((group) => !value.some(inventory => inventory.group === group.group));
            // maps the group from groupListFromDB to the expected object schema
            // { group: string, children: {...}[] }
            groupListFromDB = groupListFromDB.map((group) => {
                const children = [];
                return {
                    group: group.group,
                    children
                };
            });
            // Segregate "not set" (group of inventories that has not been set to a group)
            // and "group" (groups with related inventory items)
            // to render interface for mapping inventories to appropriate groups.
            const notSetGroup = value.filter(child => child.group === "");
            const groupsWithName = value
                .filter(child => child.group !== "")
                .concat(groupListFromDB);
            return (React.createElement("div", { className: "group-management" },
                React.createElement("div", { className: "group-management__not-set" },
                    React.createElement("h2", { className: "group-management__header" }, "Ungrouped Inventory Items"),
                    React.createElement(list_1.MaterialListNoSortRequest, { columns: columnsUngrouped, onRequestSort: this.onRequestSort, onRequestSortPriority: this.onRequestSortPriority, rows: notSetGroup, renderRow: this.renderGroupedListRowManagementNotSet, withMargin: true, wideHeader: true })),
                React.createElement("div", { className: "group-management__group" },
                    React.createElement("h2", { className: "group-management__header" }, "Groups"),
                    React.createElement(list_1.MaterialListNoSortRequest, { columns: columns, onRequestSort: this.onRequestSort, onRequestSortPriority: this.onRequestSortPriority, rows: groupsWithName, renderRow: this.renderGroupedListRowManagementGroup, withMargin: true, wideHeader: true }))));
        };
        this.handleModalClose = () => {
            this.showGroupEditModal = false;
        };
        this.handleGroupTitleEdit = (event, value) => {
            this.groupTextEditing = value.toUpperCase();
        };
        /**
         * Save an inventory group from edit.
         */
        this.handleGroupSave = async () => {
            /** Check for validity */
            const regexp = RegExp(/^[a-zA-Z0-9_-\s]{1,57}$/gi);
            const validString = regexp.test(this.groupTextEditing);
            /** Saves group to db if the group name is valid */
            if (validString) {
                const savedGroup = await store_1.inventoryListStore.saveInventoryGroup(this.groupTextEditing, this.rowToEdit);
                await store_1.inventoryListStore.loadInventoryGroup();
                await this.props.loadInventories();
            }
            else {
                this.errorMessage = ErrorMessage.Invalid;
                this.invalidGroupText = true;
            }
            this.showGroupEditModal = false;
        };
        this.removeGroup = async () => {
            await store_1.inventoryListStore.removeInventoryGroup(this.groupToBeRemoved);
            await store_1.inventoryListStore.loadInventoryGroup();
            await this.props.loadInventories();
            this.groupToBeRemoved = null; // Set to null after the group was removed
            this.showGroupRemoveConfirmation = false;
            this.makeSortable();
        };
        this.handleGroupManagementToggle = () => {
            // Clear the newQuantityToRun on toggle
            this.newQuantityToRun = {};
            this.props.handleGroupManagementToggle();
        };
        this.handleGroupManagementSave = async () => {
            const groupsMapped = html5sortable_es_js_1.default(".sortable__group-management--group", "serialize");
            const groups = groupsMapped.map((group) => {
                if (group === "") {
                    return {
                        group: group.container.node.dataset.group,
                        children: group.items.map((inventory) => inventory.node.dataset.inventoryId)
                    };
                }
                // else
                return {
                    group: group.container.node.dataset.group,
                    children: group.items.map((inventory) => {
                        const inventoryId = inventory.node.dataset.inventoryId;
                        const quantityToRun = this.newQuantityToRun[inventoryId]
                            ? this.parseQty2Run(this.newQuantityToRun[inventoryId]) ||
                                inventory.node.dataset.quantityToRun
                            : inventory.node.dataset.quantityToRun;
                        return {
                            inventoryId: inventory.node.dataset.inventoryId,
                            quantityToRun
                        };
                    })
                };
            });
            try {
                this.props.toggleConfirmGroupManagementSave("hide")();
                await store_1.inventoryListStore.saveInventoryGroupMapped(groups);
                this.handleGroupManagementToggle();
                await store_1.inventoryListStore.loadInventoryGroup();
                await this.props.loadInventories();
            }
            catch (err) {
                console.log("Error in saving inventory group sort", err);
            }
        };
        /**
         * Render the content for the modal to edit the inventory group based on the the group editing.
         * Before renderGroupModalContent is invoked, this.rowToEdit should already be set.
         */
        this.renderGroupModalContent = () => (React.createElement("div", { className: "group-modal-content" },
            React.createElement("div", { className: "group-modal-content__header" },
                !this.groupTitleEditMode && (React.createElement(core_1.Typography, { className: "group-modal-content__title", align: "center", variant: "title", color: "inherit" }, this.groupTextEditing || CONFIG.emptyText)),
                this.groupTitleEditMode && (React.createElement(text_field_1.MaterialTextFieldSortable, { className: "group", label: "Group", error: this.invalidGroupText, onChange: this.handleGroupTitleEdit, onBlur: () => (this.groupTitleEditMode = false), value: this.groupTextEditing || "" })),
                React.createElement(Button_1.default, { className: "group-modal-content__title-edit-button", variant: "flat", color: "inherit", onClick: () => (this.groupTitleEditMode = true) },
                    React.createElement(edit_1.EditIcon, { fill: "white" }))),
            React.createElement("div", { className: "group-modal-content__button-container" },
                React.createElement(Button_1.default, { onClick: this.handleModalClose }, "Cancel"),
                React.createElement(Button_1.default, { variant: "raised", color: "primary", onClick: this.handleGroupSave }, "Save"))));
        this.onRequestSort = async (property) => {
            await this.props.onRequestSort(property);
        };
        this.onRequestSortPriority = async () => {
            await this.props.onRequestSort("priority");
        };
        /**
         * @description this.inventory.claimQuantity is being saved and pulled as
         * a string that will then be parsed as an array. This function returns
         * the string with a mandatory join character; comma by default.
         * @param qty2run The quantity to run string to be parsed.
         * @returns Returns a string that can be processed to an array.
         */
        this.parseQty2Run = (qty2run) => {
            const cqArray = qty2run
                .replace(/[^,\d]/g, "")
                .split(",")
                .filter(Number)
                .map((x) => (isFinite(x) ? parseInt(x, 10) : x))
                .sort((a, b) => b - a);
            const cqSet = new Set(cqArray);
            const output = Array.from(cqSet).join(",");
            return output.length > 0 ? output : null;
        };
        /** Toggles displaying the inventories from a group based on index inventory group row clicked */
        this.handleClickGroup = (index) => {
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false ? true : false
            });
        };
    }
    render() {
        return (
        // <React.Fragment>
        React.createElement(ui_1.UiForm, { loading: this.props.loading },
            this.renderGroupedListManagement(),
            this.showGroupEditModal && (React.createElement(core_2.Modal, { open: this.showGroupEditModal, onClose: this.handleModalClose }, this.renderGroupModalContent())),
            this.showGroupRemoveConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Are you sure you want to delete this group?<br />This action cannot be undone.`, onCancel: () => (this.showGroupRemoveConfirmation = false), onConfirm: this.removeGroup, title: "Delete Confirmation" })),
            this.props.showConfirmationGroupManagementSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the managed inventory groups?`, onCancel: this.props.toggleConfirmGroupManagementSave("hide"), onConfirm: this.handleGroupManagementSave, title: "Save confirmation" }))));
    }
};
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "newQuantityToRun", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "groupToBeRemoved", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "showGroupEditModal", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "rowToEdit", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "groupTextEditing", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "showGroupRemoveConfirmation", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "groupTitleEditMode", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "invalidGroupText", void 0);
__decorate([
    mobx_1.observable
], InventoryManageGroup.prototype, "errorMessage", void 0);
InventoryManageGroup = __decorate([
    mobx_react_1.observer
], InventoryManageGroup);
exports.InventoryManageGroup = InventoryManageGroup;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-list/components/manage-group.tsx
// module id = 3496
// module chunks = 0